import { gql, useMutation } from "@apollo/client";
import { useState } from "react";
import { useFeedback } from "./feedback/Service";

const UPLOAD_PDF = gql`
  mutation UploadPdf($blob: Upload!) {
    pdfUpload(blob: $blob)
  }
`;

const initialUpload = { progress: 0, name: "", size: 1 };

const useUploadPdf = () => {
  const [uploadObject, setUploadObject] = useState(null);
  const [uploadPdf] = useMutation(UPLOAD_PDF);
  const feedback = useFeedback();

  const upload = async (file) => {
    setUploadObject({ ...initialUpload, name: file.name, size: file.size, abort: () => { } });
    try {
      const { data: { pdfUpload } } = await uploadPdf({
        variables: { blob: file },
        context: {
          fetchOptions: {
            useUpload: true,
            onProgress: (ev) => {
              // setProgress(ev.loaded / ev.total);
              setUploadObject(x => ({ ...x, progress: Math.floor((ev.loaded / ev.total) * 100) }));
            },
            onAbortPossible: (abortHandler) => {
              console.log("onAbortPossible", abortHandler);
              const abort = () => {
                console.log("abort");
                abortHandler();
                setUploadObject(null);
                feedback.snackbar({ text: "Upload cancelled", type: "info" });
              }
              setUploadObject(x => ({ ...x, abort }));
            }
          }
        }
      });
      return pdfUpload;
      // console.log("pdfUpload", getCdnFileUrl(pdfUpload));
    } catch (error) {
      console.error("upload error", error);
      feedback.snackbar({ text: "Upload error", type: "error" });
      setUploadObject(null);
    }
  }
  const reset = () => setUploadObject(null);
  return [uploadObject, upload, reset];
}

export default useUploadPdf;